// extracted by mini-css-extract-plugin
export var quantityInput = "_it-0";